import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const ReportsMainContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  marginTop: '8px',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  overflow: 'hidden',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.background.hover,
  height: 'calc(100vh - 100px)',
}));

export const TableContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(2),
  width: '100%',
}));

export const TopContainter = styled(Box)(({ theme }) => ({
  justifyContent: 'space-between',
  display: 'flex',
  width: '100%',
}));

export const MainContentReports = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(1),
}));
